import { WEIGHTS } from '../constants';

export { SIZES as TEXT_SIZES, STRETCH as TEXT_STRETCH, STYLES as TEXT_STYLES } from '../constants';

export const TEXT_WEIGHTS = WEIGHTS;
